import { ampli } from '@/ampli';
import { getABTests, getUUID } from '@/app/common/amplitude/events/ampliEventsUtils.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import type { InitialParams } from '@/app/components/hotel-detail/InitialParamsProvider.tsx';
import { canUseAmplitude } from '@/app/common/amplitude/amplitudeUtils.ts';
import type { Localization } from '@/app/components/search/common/Localization';

type AmpliProductSelectedProps = {
  searchInfoData: SearchInfoData;
  commonData: CommonData;
  localization: Localization;
  initialParams: InitialParams;
};

export const ampliProductSelected = ({
  searchInfoData,
  commonData,
  localization,
  initialParams,
}: AmpliProductSelectedProps) => {
  if (!canUseAmplitude(commonData, localization)) return;

  const { searchId, searchType } = searchInfoData;
  const { abTests } = commonData;

  const detailPageId = initialParams.productDetailKey;
  const uuid = getUUID(commonData);

  ampli.productSelected({
    ...getABTests(abTests),
    'detail page id': detailPageId,
    'features enabled': [], // TODO: Implement in a future iteration
    'search id': searchId,
    'search type': searchType,
    uuid,
  });
};
